import { render, staticRenderFns } from "./HistoricoPerfil.vue?vue&type=template&id=fe9fc280&scoped=true"
import script from "./HistoricoPerfil.vue?vue&type=script&lang=ts"
export * from "./HistoricoPerfil.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9fc280",
  null
  
)

export default component.exports